export enum FormButtonType {
    Aceptar = 'Aceptar',
    Cancelar = 'Cancelar',
    Borrar = 'Restablecer',
    Eliminar = 'Eliminar',
    Crear = 'Crear',
    Editar = 'Editar'
  }
  